"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@osmosys/utils");
const browser_1 = require("@sentry/browser");
const react_1 = require("react");
const context_1 = require("../context");
const react_use_1 = require("react-use");
const logger = utils_1.createOsmosysLogger({
    module: 'website',
    subModule: 'SentryStarter',
});
// interface IProps {
//   // nodeEnv: string;
//   // osmosysEnv: string;
//   // release: string;
//   dsn?: string;
//   children: React.ReactNode;
// }
exports.useSentry = ({ 
// osmosysEnv,
// release,
// nodeEnv,
dsn = 'https://16257d7276a24f6f98d07e455fab6bbe@sentry.io/1398625', }) => {
    const context = react_1.useContext(context_1.OsmosysAppContext);
    const ver = context.appSettings
        ? context.appSettings.version
        : process.env.GIT_SHA;
    const sentryConfig = {
        dsn,
        // environment: `${nodeEnv}:${porc}`.toLowerCase(),
        environment: window.location.hostname,
        release: `osmosys@${ver}`,
    };
    // useMemo(() => {
    //   appWasNotUpToDateSince
    //       // Sentry breadcrumb
    //       const breadcrumb = {
    //         category: 'deployment',
    //         data: {
    //           appVersion: state.appVersion,
    //           appWasNotUpToDateSince: state.appWasNotUpToDateSince,
    //           newAppVersion: data.appSettings.version,
    //           previousAppVersion: state.appVersion,
    //         },
    //         level: Severity.Info,
    //         message: 'App version became out of date. User should refresh.',
    //       };
    //       if (!appWasNotUpToDateSince) {
    //         appWasNotUpToDateSince = new Date();
    //       } else {
    //         breadcrumb.message = `App version is still out of date. User should have refreshed by now. User was first told about this at ${appWasNotUpToDateSince.toISOString()}`;
    //       }
    //       addBreadcrumb(breadcrumb);
    //     }
    //   } else {
    //     logger.warning('App version not checked');
    //     appIsUpToDate = null;
    //   }
    // }, [])
    react_use_1.useEffectOnce(() => {
        browser_1.init(sentryConfig);
        logger.info('Sentry started', {
            data: {
                NODE_ENV: process.env.NODE_ENV,
                sentryConfig,
            },
        });
    });
};
//# sourceMappingURL=useSentry.js.map